<template>
  <el-dialog
    v-el-drag-dialog
    no="ReleaseGoodsJY"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ReleaseGoodsJY')"
    :close-on-click-modal="false"
    width="550px"
    @close="dialogClose"
  >
    <div style="display: flex">
      <span>{{ $t('SeaExport.ReleaseGoods') }}</span>
      <div style="width:90%;margin-left:10px">
        <cargo-ag-grid
          config-module="2024031301"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
    </div>
    <div style="display:flex;margin-top:20px;">
      <span>{{ $t('SeaExport.Remarks') }}</span>
      <div style="width:90%;margin-left:10px">
        <el-input v-model="remark" type="textarea" :rows="5" no="16" />
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="toPostOutWhsInfo">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="dialogClose">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import { Job } from '@/class/model/booking/Job'
import { checkIfReleasedGoods, postOutWhsInfo } from '@/api/booking/jyWarehouse'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import $store from '@/store'

export default {
  name: 'JyReleaseGoodsDialog',
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: null },
    callback: { type: Function, default: null },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        singleClickEdit: true,
        rowHeight: 32,
        frameworkComponents: { CargoAgGridCommonInputEditor },
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          // 清除单选
          event.api.clearFocusedCell()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: p => {
          this.rowClicked(p)
        }
      },
      rowData: [],
      gridApi: null,
      remark: '',
      selectedWarehouseNo: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Order.WarehouseNo'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          minWidth: 200,
          editable: !this.disabled,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 400
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantity',
          colId: 'quantity',
          minWidth: 150,
          editable: !this.disabled,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              maxLength: 400
            }
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
      this.gridApi.selectAll()
    },
    rowClicked(event) {
      if (event) {
        this.selectedWarehouseNo = event.data
      }
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedWarehouseNo = node.data
          }
        })
      }
    },
    dialogClose() {
      this.$emit('update:visible', false)
    },
    async onShow() {
      this.remark = ''
      this.rowData = []
      const jobWarehouseNos = await new Job(this.job).getJobWarehouseNos()
      for (const item of jobWarehouseNos) {
        this.rowData.push({
          warehouseNo: item.warehouseNo,
          quantity: item.quantity
        })
      }
      this.$nextTick(() => {
        this.gridApi.selectAll()
      })
    },
    async toPostOutWhsInfo() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleaseSelectWarehouseNo'))
        return
      }
      const warehouseNoList = selectedRows.map(item => item.warehouseNo)
      const jobUuid = this.job.uuid
      const flg = await checkIfReleasedGoods(warehouseNoList, { jobUuid: jobUuid }).then(res => {
        return res.data
      })
      if (flg) {
        const isContinue = await this.$confirm(this.$t('SeaExport.TheWarehouseNoHasBeenReleased'), this.$t('SeaExport.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          return true
        }).catch(() => {
          return false
        })
        if (!isContinue) return
      }
      for (const item of selectedRows) {
        if (!item.quantity) {
          this.$message.warning(this.$t('SeaExport.ThePiecesCannotBeEmpty'))
          return
        }
        if (!item.warehouseNo) {
          this.$message.warning(this.$t('SeaExport.warehouseNoNotNull'))
          return
        }
      }
      const warehouse = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.warehouseCmp)
      if (!warehouse) {
        this.$message.warning(this.$t('SeaExport.warehouseNotNull'))
        return
      }
      const consigner = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', $store.getters.userId)
      if (!consigner) {
        this.$message.warning(this.$t('SeaExport.consignerNotNull'))
        return
      }
      const jyWarehouseOutPlanList = selectedRows.map(item => {
        return {
          wrNo: item.warehouseNo,
          quantity: item.quantity,
          remark: this.remark,
          bizNo: this.job.jobNo,
          consigner: consigner.chineseName ? consigner.chineseName : consigner.englishName
        }
      })
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        jobUuid: this.job.uuid,
        warehouse: warehouse.cnShortName,
        jyWarehouseOutPlanList: jyWarehouseOutPlanList
      }
      this.loading = getLoading4Cxt()
      postOutWhsInfo(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SentSuccessfully'))
        }
        this.dialogClose()
        if (this.callback) {
          this.callback()
        }
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
